import React, { Fragment } from "react";
import {
  useGetEditFormValues,
  useGetLocationFields,
} from "./Validation/UserValues";
import FormTextField from "../../../components/form/FormTextField";
import { Controller, useFormContext } from "react-hook-form";
import {
  Box,
  Checkbox,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import CountrySelector from "../../../components/form/CountrySelector";

export default function EditInformationFields({
  profile = {},
  allowEmailEdit = false,
}) {
  const { t } = useTranslation();
  const { register, formState, control } = useFormContext();
  const { errors } = formState;
  const userValues = useGetEditFormValues(profile, allowEmailEdit);
  const location = useGetLocationFields(profile);
  const titleSize = "h4";

  if (profile?.businessAccount) {
    return (
      <Fragment>
        <Wrapper>
          <Typography variant={titleSize}>
            {t("PersonalInformation")}
          </Typography>
          {userValues.map((item, index) => (
            <FormTextField
              key={index}
              defaultValue={item.defaultValue}
              label={item.label}
              name={item.name}
              required={item.required}
              errors={errors}
              maxLen={item.maxLength ?? null}
              register={register}
              testId={`profile.edit-form.${item.name}-input`}
            />
          ))}
          <Box
            display={"flex"}
            flexDirection={"row"}
            p={1}
            borderRadius={1}
            border={"1px solid GrayText"}
            color={"GrayText"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography>{t("isShelter")}</Typography>
            <Checkbox
              defaultChecked={profile?.shelter}
              defaultValue={profile?.shelter}
              {...register("shelter")}
              inputProps={{ "data-testid": "profile.edit-form.shelter-checkbox" }}
            />
          </Box>
        </Wrapper>

        <Wrapper>
          <Typography variant={titleSize}>
            {t("LocationInformation")}
          </Typography>
          <CountrySelector countryName="country" />

          {location.map((item, index) => (
            <FormTextField
              key={index}
              defaultValue={item.defaultValue}
              label={item.label}
              name={item.name}
              required={item.required}
              errors={errors}
              maxLen={item.maxLength ?? null}
              register={register}
              testId={`profile.edit-form.${item.name}-input`}
            />
          ))}
        </Wrapper>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <Wrapper>
          <Typography variant={titleSize}>
            {t("PersonalInformation")}
          </Typography>
          {userValues.map((item, index) => (
            <FormTextField
              key={index}
              defaultValue={item.defaultValue}
              label={item.label}
              name={item.name}
              required={item.required}
              errors={errors}
              maxLen={item.maxLength ?? null}
              register={register}
              testId={`profile.edit-form.${item.name}-input`}
            />
          ))}
          <Controller
            name="dob"
            control={control}
            render={({ value, onChange, field }) => (
              <MobileDatePicker
                format="DD/MM/YYYY"
                sx={{ width: "100%" }}
                label={t("DoB")}
                disableFuture
                openTo={"year"}
                value={field.value ?? null}
                onChange={(newValue) => field.onChange(newValue ?? null)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      "data-testid": "profile.edit-form.dob-input",
                    }}
                  />
                )}
              />
            )}
          />
        </Wrapper>
        <Wrapper>
          <Typography variant={titleSize}>
            {t("LocationInformation")}
          </Typography>
          <CountrySelector countryName="country" />
          {location.map((item, index) => (
            <FormTextField
              key={index}
              defaultValue={item.defaultValue}
              label={item.label}
              name={item.name}
              required={item.required}
              errors={errors}
              maxLen={item.maxLength ?? null}
              register={register}
              testId={`profile.edit-form.${item.name}-input`}
            />
          ))}
        </Wrapper>
      </Fragment>
    );
  }
}

function Wrapper({ children }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>{children}</Stack>
    </Paper>
  );
}
